import styled from 'styled-components'

export const StyledSection = styled.section<{ $spacing?: string }>`
  margin-bottom: ${({ theme, $spacing }) => {
    const spacingKey = $spacing || 'xlarge'
    return theme.spacing[spacingKey as keyof typeof theme.spacing]
  }};

  &:last-child {
    margin-bottom: 0;
  }
`

export const StyledSectionHeader = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 ${({ theme }) => theme.spacing.medium} 0;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`
